import axios from "axios"

export const AXIOS_CONFIG = {
  axios: axios.create({
    baseURL: "https://api.fitogram.pro",
    timeout: 5000,
    responseType: "json",
  }),
}
